import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBcContestApplication, permissions } from '../../../models/BcContest';
import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { BcContestApplicationEditComponent } from '../application-edit/bc-contest-application-edit.component';
import { bcState } from '../shared';

export interface IApplicationCourseInfo {
    id: number;
    code: string;
    name: string;
}

export interface IApplicationStudentInfo {
    id: number;
    name: string;
    upn: string;
}

@Component({
    templateUrl: './bc-contest-applications.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestApplicationsComponent {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private modal: NgbModal,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: {
        contestId: number,
        course?: IApplicationCourseInfo,
        student?: IApplicationStudentInfo,
        hasError?: boolean
    }) {
        this.contestId = value.contestId;
        this.course = value.course;
        this.student = value.student;
        this.hasError = value.hasError;
        this.sortBy = value.student ? 'priority' : 'place';

        if (value.student) {
            const studentColIx = this.columns.findIndex(t => t.property == 'StudentName');
            this.columns.splice(studentColIx, 1);
        }

        if (value.course) {
            const courseColIx = this.columns.findIndex(t => t.property == 'Priority');
            this.columns.splice(courseColIx, 1);
        }

        this.load();
    }

    @Input() isChild: boolean;

    readonly columns: ITableColumn[] = [
        { property: 'StudentName', label: 'bcContestApplication_lblStudent', sorts: true },
        { property: 'Priority', label: 'bcContestApplication_lblCourseByPriority', sorts: true, type: 'number' },
        { property: 'Grade', label: 'bcContestApplication_lblGrade', sorts: true, type: 'number' },
        { property: 'Place', label: 'bcContestApplication_lblPlace', sorts: true, type: 'number' },
        { property: 'AlgorithmResult', label: 'bcContestApplication_lblAlgorithmResult', sorts: true },
        { property: 'Result', label: 'bcContestApplication_lblResult', sorts: true },
        { property: 'Submitted', label: 'bcContestApplication_lblSubmitted', type: 'date' },
        { width: '1px' }
    ];

    items: IBcContestApplication[] = [];
    course?: IApplicationCourseInfo;
    student?: IApplicationStudentInfo;

    page: number = 1;
    readonly pageSize: number = 10;
    total: number = 0;
    sortBy: string;
    sortDir: 'asc' | 'desc';
    autoPage: boolean;
    canEdit: boolean;

    get isReadOnly() {
        return bcState.getContest()?.Status == 'Completed';
    }

    private contestId: number;
    private hasError?: boolean;

    ngOnInit() {
        this.canEdit = this.app.currentUser.hasRight(permissions.edit);
    }

    edit(item: IBcContestApplication) {
        const ref = this.modal.open(BcContestApplicationEditComponent);
        ref.componentInstance.data = item;
    }

    open(row: IBcContestApplication) {
        const ref = this.modal.open(BcContestApplicationsComponent, { size: 'lg' });

        ref.componentInstance.data = {
            contestId: this.contestId,
            course: this.course ? undefined : { id: row.CourseId, code: row.SubjectCode, name: row.SubjectName },
            student: this.student ? undefined : { id: row.StudentId, name: row.StudentName, upn: row.StudentUpn }
        };

        ref.componentInstance.isChild = true;
    }

    close() {
        this.activeModal.dismiss();
    }

    onPage(event: number) {
        this.page = event;

        if (!this.autoPage) this.load();
    }

    onSort(event: { sortBy: string, sortDir: 'asc' | 'desc' }) {
        this.sortBy = event.sortBy;
        this.sortDir = event.sortDir;

        if (!this.autoPage) this.load();
    }

    private load() {
        this.app.addLoading(this.service.getApplications(this.contestId, {
            courseId: this.course?.id,
            studentId: this.student?.id,
            hasError: this.hasError
        }, {
            page: this.page,
            size: this.pageSize,
            dir: this.sortDir,
            sort: this.sortBy
        })).subscribe(data => {
            this.items = data.items;
            this.total = data.total;
            this.autoPage = data.items.length == data.total;
        });
    }
}
